/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminStockItem
 */
export interface InputAdminStockItem {
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    cameraType?: InputAdminStockItemCameraTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    connectionType?: InputAdminStockItemConnectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    description?: string;
    /**
     * Атрибути дрона. Ігноруються, якщо Type != drone.
     * @type {string}
     * @memberof InputAdminStockItem
     */
    missionType?: InputAdminStockItemMissionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockItem
     */
    opticDistanceKm?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    type: InputAdminStockItemTypeEnum;
    /**
     * Атрибути боєкомплекту. Ігноруються, якщо Type != ammunition.
     * Тип БЧ і вага обов'язкові для боєкомплекту; у БД лишаються nullable —
     * наявна номенклатура заводилась без них і не має ламатись на читанні.
     * @type {string}
     * @memberof InputAdminStockItem
     */
    warheadType?: InputAdminStockItemWarheadTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockItem
     */
    weightKg?: number;
}


/**
 * @export
 */
export const InputAdminStockItemCameraTypeEnum = {
    Day: 'day',
    Night: 'night',
    Dual: 'dual'
} as const;
export type InputAdminStockItemCameraTypeEnum = typeof InputAdminStockItemCameraTypeEnum[keyof typeof InputAdminStockItemCameraTypeEnum];

/**
 * @export
 */
export const InputAdminStockItemConnectionTypeEnum = {
    Optic: 'optic',
    Starlink: 'starlink',
    Lte: 'lte',
    Ocusync: 'ocusync',
    Nakande: 'nakande'
} as const;
export type InputAdminStockItemConnectionTypeEnum = typeof InputAdminStockItemConnectionTypeEnum[keyof typeof InputAdminStockItemConnectionTypeEnum];

/**
 * @export
 */
export const InputAdminStockItemMissionTypeEnum = {
    Radio: 'radio',
    Digital: 'digital',
    Bomber: 'bomber'
} as const;
export type InputAdminStockItemMissionTypeEnum = typeof InputAdminStockItemMissionTypeEnum[keyof typeof InputAdminStockItemMissionTypeEnum];

/**
 * @export
 */
export const InputAdminStockItemTypeEnum = {
    Drone: 'drone',
    Ammunition: 'ammunition'
} as const;
export type InputAdminStockItemTypeEnum = typeof InputAdminStockItemTypeEnum[keyof typeof InputAdminStockItemTypeEnum];

/**
 * @export
 */
export const InputAdminStockItemWarheadTypeEnum = {
    Cumulative: 'cumulative',
    FragCumulative: 'frag_cumulative',
    Frag: 'frag',
    He: 'he',
    Thermobaric: 'thermobaric',
    Incendiary: 'incendiary'
} as const;
export type InputAdminStockItemWarheadTypeEnum = typeof InputAdminStockItemWarheadTypeEnum[keyof typeof InputAdminStockItemWarheadTypeEnum];


/**
 * Check if a given object implements the InputAdminStockItem interface.
 */
export function instanceOfInputAdminStockItem(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function InputAdminStockItemFromJSON(json: any): InputAdminStockItem {
    return InputAdminStockItemFromJSONTyped(json, false);
}

export function InputAdminStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'cameraType': json['cameraType'] == null ? undefined : json['cameraType'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'description': json['description'] == null ? undefined : json['description'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'name': json['name'],
        'opticDistanceKm': json['opticDistanceKm'] == null ? undefined : json['opticDistanceKm'],
        'type': json['type'],
        'warheadType': json['warheadType'] == null ? undefined : json['warheadType'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
    };
}

export function InputAdminStockItemToJSON(value?: InputAdminStockItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cameraType': value['cameraType'],
        'connectionType': value['connectionType'],
        'description': value['description'],
        'missionType': value['missionType'],
        'name': value['name'],
        'opticDistanceKm': value['opticDistanceKm'],
        'type': value['type'],
        'warheadType': value['warheadType'],
        'weightKg': value['weightKg'],
    };
}

